/**
 * Bed Type to Display Name Mapping
 * Maps abbreviated bed type codes to user-friendly display names
 */

export const BED_TYPE_MAPPING: { [key: string]: string } = {
  '1K': 'ONE KING',
  '2K': 'TWO KING',
  '3K': 'THREE KING',
  '1D': 'ONE DOUBLE',
  '2D': 'TWO DOUBLE',
  '1Q': 'ONE QUEEN',
  '2Q': 'TWO QUEEN',
  'STE': 'SUITE',
  'CON': 'CONNECTOR',
  'NA': 'OTHER'
};

/**
 * Get the display name for a bed type
 * @param bedType - The bed type code (e.g., '1K', '2Q')
 * @returns The display name if found, otherwise returns the original bedType
 */
export function getBedTypeDisplayName(bedType: string): string {
  if (!bedType) {
    return '';
  }
  return BED_TYPE_MAPPING[bedType] || bedType;
}
